export default __webpack_public_path__ + "static/virtual-436f3db689b4dbbadf2015631dc9aefb.png";